//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/ScCollector.js";
import "../no/SelectFaceList.js";
import "../no/DisplayableObject.js";
import "../no/GeometricAnalysis.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"BodyPreference",1,0],[0,"BoundaryDisplay",1,0],[0,"CheckTangency",1,0],[0,"IsCommonFacesSearched",1,0],[0,"KeepTarget",1,0],[0,"KeepTool",1,0],[0,"LineWidth",1,0],[0,"OptimizeFaces",1,0],[0,"OutputMultipleSheets",1,0],[0,"SewAllInstances",1,1],[0,"SheetBoundaryAOBuilder",1,"GeometricAnalysis.SheetBoundaryAnalysisBuilder",0],[0,"SheetBoundaryColor",1,0],[0,"ShowBoundaryVertices",1,0],[1,"TargetBodies",0,"SelectDisplayableObjectList",1],[1,"TargetBodiesCollector",0,"ScCollector",0],[1,"TargetFaces",0,"SelectFaceList",0],[0,"Tolerance",1,0],[1,"ToolBodies",0,"SelectDisplayableObjectList",1],[1,"ToolBodiesCollector",0,"ScCollector",0],[1,"ToolFaces",0,"SelectFaceList",0],[0,"Type",1,0]],[[["numUnsewnBodies"],"GetUnsewnBodies",{R_:{unsewnBodies:"NXObject[]"}},0,0]],[]];
SPLM.Features.SewBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SewBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SewBuilder.Types = Object.freeze({
    "Sheet" : "Sheet", "Solid" : "Solid"});

SPLM.Features.SewBuilder.BodyPreferenceTypes = Object.freeze({
    "Solid" : "Solid", "Sheet" : "Sheet"});

SPLM.Features.SewBuilder.BoundaryDisplayValue = Object.freeze({
    "None" : "None", "Temporary" : "Temporary", "Persistent" : "Persistent"});

export default SPLM;